import type React from 'react';
import { useEffect, useRef, useState } from 'react';
import type { Editor } from '@tiptap/react';
import IcoFontColor from 'components/icon/icons/IcoFontColor';
import { PyMuiIconButton } from 'components/editor/GridDndEditor/TiptapEditor/components/generalComponents';
import type { ColorResult } from 'components/editor/shared/components/ColorPicker';
import { ColorPopup } from 'components/editor/shared/components/ColorPicker';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

const CustomFillWrapper = styled(Box)<{ color?: string }>`
  svg path:nth-of-type(1) {
    fill: ${(props) => props.color || 'rgba(0,0,0,0.87)'};
  }
  svg path:last-child {
    fill: rgba(0, 40, 58, 0.87);
  }
`;

type Props = {
  editor: Editor;
};

const TextColorButton: React.FC<Props> = ({ editor }) => {
  const iconRef = useRef<HTMLSpanElement>(null);
  const [open, setOpen] = useState(false);
  const [color, setColor] = useState<string>(editor.getAttributes('textStyle')?.color);

  useEffect(() => {
    const handler = () => {
      const color = editor.getAttributes('textStyle')?.color;
      setColor(color);
    };
    editor.on('selectionUpdate', handler);
    editor.on('transaction', handler);
    return () => {
      editor.off('selectionUpdate', handler);
      editor.off('transaction', handler);
    };
  }, [editor]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = (picked: ColorResult, isValueSet: boolean) => {
    if (isValueSet) {
      editor.chain().focus().setColor(picked).run();
    }
    setOpen(false);
  };

  return (
    <>
      <PyMuiIconButton attributeName="text-color" onClick={handleOpen} isActive={open}>
        <span ref={iconRef} data-testid={'text-color'}>
          <CustomFillWrapper color={color}>
            <IcoFontColor style={{ padding: '3px 2px 0 2px' }} />
          </CustomFillWrapper>
        </span>
      </PyMuiIconButton>
      <ColorPopup buttonRef={iconRef} currentColor={color} onClose={handleClose} open={open} />
    </>
  );
};

export default TextColorButton;
